import { PATH } from "../../router/path";

export const list = [
  { title: "Личный состав", path: PATH.CATALOGUES_STAFF },
  { title: "Авиабазы и авиаотделения", path: PATH.CATALOGUES_BASES },
  { title: "Типы воздушных судов", path: PATH.CATALOGUES_TRANSPORT },
  { title: "Подрядчики", path: PATH.CATALOGUES_CONTRACTORS },
  { title: "Договоры", path: PATH.CATALOGUES_CONTRACTS },

  /*     относятся к договорам
    {title: "Воздушные суда", path: PATH.CATALOGUES_CONTRACT_AIRCRAFTS},
    {title: "Стоимость 1 часа по видам работ", path: PATH.CATALOGUES_CONTRACT_WORKS}, */
  { title: "Виды работ", path: PATH.CATALOGUES_WORKS },
  { title: "Налеты", path: PATH.FLYGHTS },
];
